import React from "react";
import { LogbookPage } from "./LogbookPage";

export const MESFLogbookEntry = () => {
	return <LogbookPage />;
};
